import useSWR from 'swr';
import useSWRImmutable from 'swr/immutable';
export default class APIFileManager {

  getHeadersWithContentType(arg0: string | undefined): HeadersInit | undefined {
    throw new Error("Method not implemented.");
  }

  getURLSearchParams(object: any) {
    throw new Error("Method not implemented.");
  }

  fetcher(url: string) {
    throw new Error("Method not implemented.");
  }

  async createFolder(currentPath: string, folderName: string) {

    const response = await fetch(`${process.env.NEXT_PUBLIC_API_URL}/api/file-manager/folder`, {
      method: 'POST',
      headers: this.getHeadersWithContentType('application/json'),
      body: JSON.stringify({
        path: currentPath,
        name: folderName
      })
    });

    return response.ok;
  }

  async deleteObjects(paths: Array<string>) {

    const response = await fetch(`${process.env.NEXT_PUBLIC_API_URL}/api/file-manager/`, {
      method: 'DELETE',
      headers: this.getHeadersWithContentType('application/json'),
      body: JSON.stringify({ paths })
    });

    return response.ok;
  }

  async listObjects(path: string) {

    const response = await fetch(`${process.env.NEXT_PUBLIC_API_URL}/api/file-manager/navigate/?path=${path}`, {
      method: 'GET',
      headers: this.getHeadersWithContentType('application/json'),
    });

    if (!response.ok) {
      return false;
    }

    const json = await response.json();
    return json;
  }

  async copyObjects(content: any) {

    const response = await fetch(`${process.env.NEXT_PUBLIC_API_URL}/api/file-manager/copy`, {
      method: 'POST',
      headers: this.getHeadersWithContentType('application/json'),
      body: JSON.stringify({
        ...content
      })
    });

    return response.ok;
  }

  async moveObjects(content: any) {

    const response = await fetch(`${process.env.NEXT_PUBLIC_API_URL}/api/file-manager/move`, {
      method: 'POST',
      headers: this.getHeadersWithContentType('application/json'),
      body: JSON.stringify({
        ...content
      })
    });

    return response.ok;
  }

  async downloadFile(path: string) {

    const response = await fetch(`${process.env.NEXT_PUBLIC_API_URL}/api/file-manager/object/?path=${path}`, {
      method: 'GET',
      headers: this.getHeadersWithContentType('application/json'),
    });


    if (!response.ok) {
      return false;
    }

    const { url } = await response.json();
    return url;
  }

  async downloadZip(paths: Array<string>) {

    const response = await fetch(`${process.env.NEXT_PUBLIC_API_URL}/api/file-manager/zip`, {
      method: 'POST',
      headers: this.getHeadersWithContentType('application/json'),
      body: JSON.stringify({
        paths
      })
    });

    if (!response.ok) {
      return false;
    }

    const { zip_id } = await response.json();
    if (!zip_id) {
      return false;
    }

    return `${process.env.NEXT_PUBLIC_API_URL}/api/file-manager/zip/${zip_id}`;
  }

  async startUpload(content: { path: string, name: string, size: number }) {

    const response = await fetch(`${process.env.NEXT_PUBLIC_API_URL}/api/file-manager/upload`, {
      method: 'POST',
      headers: this.getHeadersWithContentType('application/json'),
      body: JSON.stringify({
        files: [content]
      })
    });

    if (!response.ok) {
      return false;
    }

    const json = await response.json();
    return json[0];
  }

  async completeUpload(uploadId: string, content: { path: string, parts: Array<{ part_number: string, e_tag: string }> }) {

    const response = await fetch(`${process.env.NEXT_PUBLIC_API_URL}/api/file-manager/upload/${uploadId}`, {
      method: 'POST',
      headers: this.getHeadersWithContentType('application/json'),
      body: JSON.stringify(content)
    });

    return response.ok;
  }

  useFileManager(path: string) {

    const params = new URLSearchParams();
    params.append('path', path)
    const endpoint = `${process.env.NEXT_PUBLIC_API_URL}/api/file-manager/navigate/?${params}`
    const { data, error, isLoading, mutate } = useSWR(endpoint, this.fetcher)

    return {
      data: data,
      error: error,
      isLoading: isLoading,
      mutate: mutate
    }
  }

  useFileManagerSearch(path: string | null, term: string) {

    const params = new URLSearchParams();
    params.append('path', path)
    params.append('term', term)
    const endpoint = (path === null || term.length == 0) ? null : `${process.env.NEXT_PUBLIC_API_URL}/api/file-manager/search/?${params}`
    const { data, error, isLoading, mutate } = useSWR(endpoint, this.fetcher)

    return {
      data: data,
      error: error,
      isLoading: isLoading,
      mutate: mutate
    }
  }

  useFileManagerObjectInfo(path: string) {

    const params = new URLSearchParams();
    params.append('path', path)
    const endpoint = `${process.env.NEXT_PUBLIC_API_URL}/api/file-manager/info/?${params}`
    const { data, error, isLoading, mutate } = useSWRImmutable(endpoint, this.fetcher)

    return {
      data: data,
      error: error,
      isLoading: isLoading,
      mutate: mutate
    }
  }
}
